import { route } from 'preact-router';
import { error, loading } from '../store/state';
import { register } from '../store/actions/auth.actions';

export function RegistroView() {
  const onSubmit = (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    register(
      String(fd.get('empresa')),
      String(fd.get('slug')),
      String(fd.get('nombre')),
      String(fd.get('email')),
      String(fd.get('password'))
    );
  };

  return (
    <div class="login-wrap">
      <h1>Registrar empresa</h1>
      <p class="subtitle">Creá tu cuenta</p>
      <form onSubmit={onSubmit}>
        <label>Nombre de empresa</label>
        <input name="empresa" required />
        <label>Identificador</label>
        <input name="slug" required placeholder="ej: mi-empresa" pattern="[a-z0-9-]+" />
        <label>Tu nombre</label>
        <input name="nombre" required />
        <label>Email</label>
        <input name="email" type="email" required />
        <label>Contraseña</label>
        <input name="password" type="password" required minLength={6} />
        <button class="primary" type="submit" disabled={loading.value}>
          Crear cuenta
        </button>
      </form>
      <p style={{ textAlign: 'center', marginTop: 16, fontSize: 14 }}>
        <a
          href="/login"
          style={{ color: 'var(--primary)' }}
          onClick={(e) => {
            e.preventDefault();
            error.value = null;
            route('/login');
          }}
        >
          Iniciar sesión
        </a>
      </p>
    </div>
  );
}
